import React from 'react';
import QuoteBookingCard from 'components/quoteBooking/QuoteBookingCard';

export default function QuoteBookingCardList({ list = [], isBooking = false }) {
  return (
    <>
      {list.map((item) => (
        <React.Fragment key={`key-${item.id}`}>
          <QuoteBookingCard item={item} isBooking={isBooking} key={item.id} />
        </React.Fragment>
      ))}
    </>
  );
}
